<script lang="ts">
	import magnifier from "@core/assets/icons/magnifier.svg?raw";
	import { Locale } from "@core/schema/Locale.js";
	import type { PublishedNews } from "@core/schema/News.js";
	import { getBlogPath } from "@core/schema/paths/getBlogPath.js";
	import BlogArticleCard from "../common/BlogArticleCard.svelte";
	import Link from "../common/Link.svelte";
	import { ButtonVariant } from "../common/getButtonClass.js";

	const {
		articles,
	}: {
		articles: PublishedNews[];
	} = $props();

	const blogUrl = $derived(getBlogPath(Locale.cs));
</script>

<section class="full-width py-12 md:py-16 lg:py-20 bg-ivory-50">
	<div class="flex flex-col items-center gap-8 md:gap-12 px-4 md:px-8 max-w-7xl mx-auto">
		<h2 class="text-center w-full">Novinky z péče o vlasy</h2>

		{#if articles.length > 0}
			<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 w-full">
				{#each articles as article (article.id)}
					<BlogArticleCard {article} />
				{/each}
			</div>

			<Link variant={ButtonVariant.PrimaryMedium} href={blogUrl} iconStart={magnifier}>Zobrazit další články</Link>
		{:else}
			<p class="text-center text-[#7D7D7D]">Zatím zde nejsou žádné články.</p>
		{/if}
	</div>
</section>
